// Resolve API URL at runtime — handles custom domain deployments
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (!envUrl) return '';
  try {
    const envHost = new URL(envUrl).hostname;
    const currentHost = window.location.hostname;
    if (envHost !== currentHost) return '';
  } catch (e) {
    return '';
  }
  return envUrl;
};

export const API_URL = getApiUrl();

/**
 * Extract a user-friendly error message from an axios error response.
 * Strips raw JSON / HTTP codes and returns clean text.
 */
export function formatApiError(error, fallback = 'Something went wrong. Please try again.') {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail !== 'string') return fallback;

  // Already clean from backend parse_middleware_error
  return detail;
}
